import React from "react";
import R14, { StyleSheet, AsyncStorage, View, Image, Text, Platform } from "../core";
import FilterComponent from "../components/FilterComponent";

import DateUtils from "../utils/DateUtils";
import { CURRENCY, BILL_STATUS, MSG_TYPE, PAGE_PATH, } from "../constant/app.data.constant";

import { CommonString } from "../constant/appCommonText";
import JsonToCSV from "../utils/JsonToCSV";
import HtmlDecode from "../utils/HtmlDecode";
import { commonStyles } from "../assets/css/commonStyle";
import { responsiveTableStyle } from "../assets/css/responsiveTableStyle";
import { commonMetricsStyle } from "../assets/css/commonMetricsStyle";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import HeaderTitleComponent from "../components/HeaderTitleComponent";
import ViewAllBillsColumnTableComponent from "../components/ViewAllBillsColumnTableComponent";
import ViewAllBillsGridTableComponent from "../components/ViewAllBillsGridTableComponent";
import Touchable from "../components/TouchableComponent";
import StatusComponent from "../components/StatusComponent";
import FilterIconComponent from "../components/FilterIconComponent";
import { customCommonStyles } from "../assets/css/customCommonStyle";
import CommonUtility from "../utils/CommonUtility";
import attachedFileIcon from "../assets/images/attachedFileIcon.png";
import removeFilterIcon from "../assets/images/NewRemoveFilterIcon.png";

export default R14.connect(
  class MakePaymentScreen extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        pageData: [],
        totalRows: 0,
        page: 1,
        pageReRender: 0,
      }
    }

    async componentDidMount() {
      const { isMobileDevice } = this.props.app.dm.notificationDomain.state;
      if(isMobileDevice) {
        this.props.app.dm.userSession.setState({ isLoading: true });
        this.getPageData({}, {}, false);
        await this.getPageData({}, {}, false);
        this.setState({pageReRender: this.state.pageReRender + 1})
      }
      AsyncStorage.setItem(CommonString.LOCAL_STORAGE_HOMESCREEN, this.props.r14.navigation.activeRouteName);
    }

    componentWillUnmount() {
      this.setState({pageData: [], totalRows: 0, page: 1, pageReRender: 0});
    }

    onCheckboxChange = (selectedChk) => {
      this.props.app.dm.filterDomain.setState({ selectedChk });
    };

    onDateChkboxChange = (selectedDateChk) => {
      this.props.app.dm.filterDomain.setState({ selectedDateChk });
    };

    onSwitchChange = (sortOrder) => {
      this.props.app.dm.filterDomain.setState({ sortOrder });
    };

    onStatusChange = async (ind) => {
      const { statusType } = this.props.app.dm.filterDomain.state;
      statusType[ind].isSelected = !statusType[ind].isSelected;
      this.props.app.dm.filterDomain.setState({ statusType });
    };
    applyFilter = async () => {
      this.props.app.dm.userSession.setState({ isLoading: true });
      this.getPageData();
      return false;
    };

    onCloseFilter = () => {
      const {
        selectedStatus,
        selectedChk,
        sortOrder,
        statusType,
        radioOpt,
        selectedDateChk,
        fromDate,
        toDate
      } = this.props.app.dm.filterDomain.state.oldFilterState;
      this.props.app.dm.filterDomain.setState({
        isFilterOpen: false,
        selectedChk,
        sortOrder,
        statusType,
        radioOpt,
        selectedStatus,
        selectedDateChk,
        fromDate,
        toDate
      });
    };

    onCrossClick = async (el) => {
      let { selectedStatus, statusType } = this.props.app.dm.filterDomain.state;
      statusType.forEach((itm) => {
        if (itm.label.toLowerCase() === el.toLowerCase()) {
          itm.isSelected = false;
        }
      });
      let idx = selectedStatus.indexOf(el);
      if (idx > -1 && !(el === "Date Range" || el === "Biller")) {
        selectedStatus.splice(idx, 1);
        await this.props.app.dm.filterDomain.setState({ selectedStatus: selectedStatus, statusType: statusType });
      } else if (el === "Date Range" || el === "Biller") {
        selectedStatus = selectedStatus.filter(status => status !== el);
        if (el === "Date Range") {
          await this.props.app.dm.filterDomain.setState({ selectedStatus: selectedStatus, selectedDateChk: "billDate", fromDate: null, toDate: null });
        }
        if (el === "Biller") {
          await this.props.app.dm.filterDomain.setState({ selectedStatus: selectedStatus, selectedBU: "" });
        }
      }
      this.props.app.dm.userSession.setState({ isLoading: true });
      this.applyFilter();
    };

    onNavigate = (item) => {
        const { threadId } = item;
        let newThreadId = threadId; //.replaceAll("#", ">>");
        this.props.app.dm.billDetails.setState({
          billDetails: item
        });
        this.props.app.nav.to("billDetailsRoute", { threadId: newThreadId });
    };

    onBulkPaymentNavigation = async (getData = []) => {
      try {
        let bulkBills = [...getData];
        let billerList = await this.props.app.dm.rest.getBillers();
        bulkBills.forEach((bill) => {
          let biller = billerList.find(x => x.billerId.toLowerCase() === bill.billerId.toLowerCase());
          if (!!biller && !!biller.uid)
          {
              bill.biller.isPaymentsFull = biller.isPaymentsFull;
              bill.biller.isPaymentsPartial = biller.isPaymentsPartial;
          }
        });

        bulkBills = bulkBills.filter(bill => {
          return (
            !["In Process", 'Declined', 'Paid'].includes(bill.paymentStatus ? bill.paymentStatus : bill.billStatus) &&
            (bill.biller.isPaymentsFull || bill.biller.isPaymentsPartial)
            && !!!bill.isExtentionRequested
            // if isBillerBlocked is true than remove bill from bulk pay
            && !!!bill.biller.isBillerBlocked
          )
        });

        if (!!bulkBills && bulkBills.length > 0) {
          this.props.app.dm.dashboard.setState({ bulkPayBills: bulkBills })
          this.props.app.nav.to("bulkPaymentRoutes")
        } else if (!!bulkBills && bulkBills.length === 0){
          if (!!getData && getData.length){
            this.props.app.dm.commonDomain.showToastr("error", CommonString.NoBillApplicable);
          } else this.props.app.dm.commonDomain.showToastr("error", CommonString.NoBillFound);
        }
      } catch (error) {
          console.error(error);
          this.props.app.dm.commonDomain.showToastr("error", CommonString.SomethingWentWrong);

      }
    };

    showPayType = async(data) => {
        this.props.app.dm.billDetails.setState({
          billDetails: data
        });
        this.setState({ isPayNowVisible: false, selectedThreadId: data.threadId });
        let payType = !!data && !!data.biller && !!data.biller.isPaymentsFull ? PAGE_PATH.PAYFULL : !!data && !!data.biller && !!data.biller.isPaymentsPartial ? PAGE_PATH.PAYPART : "";

        if(MSG_TYPE.PAY_PART === data.rtpMessageType && data.amountPaid > 0 && data.amountPaid < data.billAmount)
          payType = PAGE_PATH.PAYPART;
  
        if (!!payType) 
          this.props.app.nav.to("payTypeRoute", { paytype: payType });
      return false;
    }

    toggleBookmark = async (el) => {
      const { pageData } = this.state;
      const {  bookmark } = this.props.app.dm.dashboard.state;
      let bookmarkIdx = bookmark?.nodes?.findIndex((itm) => itm?.threadId === el.threadId);
      let pageDataIdx = pageData.findIndex((itm) => itm?.threadId === el.threadId);
      let res = await this.props.app.dm.dashboard.addUpdateBookmark({
        bookmark: !el.bookmark,
        uid: el.uid,
      });
      if (res.uid) {
        if(res.bookmark === false) {
          delete bookmark.nodes[bookmarkIdx];
          bookmark.totalCount = bookmark.totalCount - 1;
        } else {
          bookmark.nodes.push(el);
          bookmark.totalCount = bookmark.totalCount - 1;
        }
        this.props.app.dm.dashboard.setState({ bookmark });
        pageData[pageDataIdx].bookmark = res.bookmark;

        this.props.app.dm.commonDomain.showToastr("success", el.bookmark ? CommonString.BillBookmarked : CommonString.BillUnBookmarked);
        this.setState({pageData});
      }
    };
    navigateTo = async (path) => {
      this.props.app.nav.to(path);
    };

    onRestoreFilter = () => {
      const { isMobileDevice } = this.props.app.dm.notificationDomain.state;
      this.props.app.dm.filterDomain.resetFilter();
      if(isMobileDevice) {
        this.props.app.dm.userSession.setState({ isLoading: true });
        this.getPageData();
      }
    };

    CheckPaymentAllowOrNot = (item) => {
      let isPayNowDistable = true;
      if ([MSG_TYPE.PAY_ALL, MSG_TYPE.REQ_PAY_EXT].includes(item.rtpMessageType) || BILL_STATUS[item.billStatus] || item.billStatus === "In Process") {
        isPayNowDistable = false;
      }
      else if (!!isPayNowDistable && !!!item?.biller?.isPaymentsFull && !!!item?.biller?.isPaymentsPartial) {
        isPayNowDistable = false;
      }

      if(MSG_TYPE.PAY_PART === item.rtpMessageType && item.amountPaid < item.billAmount)
        isPayNowDistable = true;

      if (item.billStatus === "Failed" && (!!item.biller.isPaymentsFull || !!item.biller.isPaymentsPartial)) {
        isPayNowDistable = true;
      }
      
      return isPayNowDistable;
    }

    convertToCSV = async() => {
      let items = this.state.pageData;
      if (items.length){
          items = items.map(item => {
            return {
              "Biller Name": item.billerName || item.biller.billerName,
              "Bill Subject": item.subject,
              "Account Number": item.accountNumber || "N/A",
              "Creation Date": DateUtils.formatDate(item.billDate),
              "Due On": DateUtils.dataTableDateFormatter(item.dueDate),
              "Status": item.billStatus,
              "Initial Amount": `${CURRENCY[item.currency]}${CommonUtility.formatAmount(item.billAmount.toFixed(2), this.props.app)}`,
              "Paid Amount": `${CURRENCY[item.currency]}${CommonUtility.formatAmount(item.amountPaid.toFixed(2), this.props.app)}`,
              "Amount Payable": `${CURRENCY[item.currency]}${CommonUtility.formatAmount(item.amountDue.toFixed(2), this.props.app)}`,
              "Reference ID": item.endToEndIdentification,
            }
          })
        const csvContent = JsonToCSV.convertJsonToCSV(items);
        HtmlDecode.downloadUTF8file({
          content: csvContent,
          filename: `${"Make Payment"}_${DateUtils.formatYYYYMMDDHHMMSS()}.csv`
        })
      }
      return false;
    }


    getPageData = async (
      query = {},
      options = {},
      loaderShown = true
    ) => {
      try {
        if(loaderShown) this.props.app.dm.userSession.setState({ isLoading: true });
        if (!this.props.app) return { pageData: [], totalRows: 0 };
        const { page = null, rowsPerPage = 10, sortColumnName, sortDirection, search = "" } = query;
        const { selectedChk, sortOrder, statusType, radioOpt, selectedBU, fromDate, toDate, selectedDateChk } = this.props.app.dm.filterDomain.state;

        let selectedStatus = statusType.filter((el) => el.isSelected === true)
        let selectedStatusList = selectedStatus.map((itm) => itm.label);
        const selectedBillStatus = [];
        const selectedPaymentStatus = [];

        selectedStatus.forEach((itm) => {
          if(itm.groupLabel === "Bills" && itm.label !== "Priority") selectedBillStatus.push(itm.label)
          else if(itm.groupLabel === "Payment") selectedPaymentStatus.push(itm.label)
        });

        if (selectedDateChk && (fromDate || toDate)) selectedStatusList.push("Date Range");
        if (selectedBU && selectedBU.label) selectedStatusList.push("Biller");
        this.props.app.dm.filterDomain.setState({
          selectedStatus: selectedStatusList,
          showResetFilterBtn: true, isFilterOpen: false,
          oldFilterState: { selectedChk, sortOrder, selectedStatus: selectedStatusList, statusType, radioOpt, selectedDateChk, fromDate, toDate },
        });
        const pageNo = page === null ? this.state.page : page;
        let res = !this.props.app ? {} : await this.props.app.dm.dashboard.setCompiledMsgList(
          {
            page: pageNo,
            resultsPerPage: rowsPerPage,
            ...(!!search ? {search} : {}),
            filter: {
              ...(!!selectedBillStatus && selectedBillStatus.length ? {billStatus: { in: selectedBillStatus }} : {}),
              ...(!!selectedPaymentStatus && selectedPaymentStatus.length  ? {paymentStatus: { in: selectedPaymentStatus }} : {}),
              ...(selectedDateChk === "dueDate" ? {dueDate: { eq:  JSON.stringify([fromDate, toDate]) }} : {}),   // for date range
              ...(selectedDateChk === "billDate" ? {billDate: { eq: JSON.stringify([fromDate, toDate]) }} : {}),  // for date range
              ...(!!selectedBU && selectedBU.value ? {billerUid: { eq: selectedBU.value }} : {}),
              ...(!!selectedStatusList.includes("Requested") ? {isExtentionRequested: true } : {}),
              ...(!!selectedStatusList.includes("Approved") ? {isExtentionApproved: true } : {}),
              ...(!!selectedStatusList.includes("Rejected")  ? {isExtentionDeclined: true } : {}),
              ...(!!selectedStatusList.includes("Priority") ? {bookmark: true } : {}),
            },
            ...(selectedChk || sortColumnName ? {sort: [{  field: selectedChk || sortColumnName, order: sortOrder?.toUpperCase() || sortDirection.toUpperCase()  }]} : {})
          }
        );
        this.setState({pageData: res.nodes, totalRows: res.totalCount, page: pageNo});
        return {
          pageData: res.nodes,
          totalRows: res.totalCount
        };
      } catch (error) {
        this.setState({pageData: [], totalRows: 0});
        return {
          pageData: [],
          totalRows: 0
        };
      } finally {
        this.props.app.dm.userSession.setState({ isLoading: false });
      }
    }

    renderSelectedFilterOpt() {
      const { selectedStatus, showResetFilterBtn } = this.props.app.dm.filterDomain.state;
      const statusOtp = selectedStatus;
      return !!statusOtp && !!statusOtp.length ? (
        <View
          style={[
            commonStyles.flex1,
            commonStyles.flexDirectionRow,
            commonStyles.justifyContentSpaceBetween,
            responsiveTableStyle.filterBySection,
            !!statusOtp && !!statusOtp.length ? responsiveTableStyle.filterBySectionWithFiler : null,
            commonStyles.marginLtRt10,
            commonStyles.paddingLeftRight16
          ]}>
          <View style={[responsiveTableStyle.filtereHading]}>
            <Text style={[responsiveTableStyle.marB10, commonFontStyles.workSans, commonMetricsStyle.heading6, commonStyles.fontWeight600]}>Filter by: </Text>
          </View>
          <View style={[commonStyles.flex1, commonStyles.flexDirectionRow, commonStyles.flexGrow1, commonStyles.flexWrap, commonStyles.alignItemsCenter]}>
            {statusOtp.map((el, ind) => (
              <StatusComponent
                key={ind}
                label={el}
                isSelected={true}
                circleNotAllowed={true}
                hasClose
                marginBottom={[commonStyles.marB0]}
                onCrossClick={() => this.onCrossClick(el)}
                wrapperStyle={[styles.statusWrapperStyle]}
              />
            ))}
          </View>
          {!!statusOtp && !!statusOtp.length ? (
            <View tooltip={'Remove All Filters'} style={[commonStyles.marginLeftRight16, commonStyles.marginRight8]}>
                <Touchable onPress={this.onRestoreFilter} hidden={!showResetFilterBtn}>
                  <View>
                    <Image source={removeFilterIcon} style={commonStyles.icon18} />
                  </View>
                </Touchable>
            </View>
          ) : null
          }
        </View>
      ) : null;
    }

    render() {
      const { isFilterOpen, selectedChk, sortOrder, statusType, selectedStatus, radioOpt, selectedDateChk, showResetFilterBtn } = this.props.app.dm.filterDomain.state;
      let option = { selectedChk, sortOrder, statusType, selectedStatus, radioOpt, selectedDateChk, showResetFilterBtn };
      const { isMobileDevice } = this.props.app.dm.notificationDomain.state;

      const { pageData, totalRows, page, pageReRender } = this.state;
      return (
        <View style={[customCommonStyles.childMainContainer]}>
          {!!isMobileDevice && <FilterComponent
            isVisible={isFilterOpen}
            defaultFilter={option}
            onCancelFilter={this.onCloseFilter}
            onFilter={this.applyFilter}
            onCheckboxChange={this.onCheckboxChange}
            onSwitchChange={this.onSwitchChange}
            onStatusChange={this.onStatusChange}
            billerNameList={this.props.billers}
            onDateChkboxChange={this.onDateChkboxChange}
          />}
          <View style={[Platform.OS !== "web" ? [commonStyles.minHeightFull] : [commonStyles.flex1, commonStyles.flexDirectionColumn, customCommonStyles.webFullHeight]]}>
              <HeaderTitleComponent
                title={"All Bills"}
                convertToCSV={() => this.convertToCSV()}
                getPageData={this.getPageData}
                isSearchIcon={true}
                isAddMessage={false}
                downloadCsv={true}
                filterIcon={true}
                dataSort={false}
                sortingFields={[{key: 'Date', value: 'lastMessageDate'}]}
              />
              {isMobileDevice && <View style={[responsiveTableStyle.filterBySectionWrapper]}>{ this.renderSelectedFilterOpt()}</View>}
              <View style={[commonStyles.flex1, commonStyles.flexDirectionRow, ]}>
                {isMobileDevice ? (
                  pageReRender >= 1 || pageData.length ? 
                  <ViewAllBillsColumnTableComponent
                    onProfileIcon={(item) => this.onNavigate(item)}
                    getPageData={this.getPageData}
                    pageData={pageData}
                    totalRows={totalRows}
                    page={page}
                    rowsPerPage={10}
                    isDashboardScreen={true}
                    showPayType={this.showPayType}
                    CheckPaymentAllowOrNot={this.CheckPaymentAllowOrNot}
                    toggleBookmark={this.toggleBookmark}
                    message={"No bills to display."}
                  /> : null
                ) : (
                  <View style={[commonStyles.flex1, commonStyles.flexDirectionColumn]}>
                <ViewAllBillsGridTableComponent
                  name={'clients'}
                  labelKeys={[
                    {label: "", width: 35},
                    {label: "Biller"},
                    {label: "Bill Subject"},
                    {label: "Creation Date"},
                    {label: "Due On"},
                    {label: "Status"},
                    {label: "Amount"},
                    {label: "Action", width: 130}
                  ]}
                  billers={this.props.billers}
                  labelValues={["bookmark", "biller.billerName", "subject", "billDate", "dueDate", "paymentStatus", "billAmount", "Detail"]}
                  onActionClick={(item, act) => console.log(item, act)}
                  onProfileIcon={(item) => this.onNavigate(item)}
                  message={"No bills to display."}
                  amountTypeFields={["billAmount",]}
                  dateTypeFields={["billDate", "dueDate"]}
                  profileIcon={"biller.billerName"}
                  searchable={true}
                  rowControlsRight={null}
                  handleCross={this.onCrossClick}
                  getPageData={this.getPageData}
                  rowsPerPage={10}
                  showPayType={this.showPayType}
                  CheckPaymentAllowOrNot={this.CheckPaymentAllowOrNot}
                  toggleBookmark={this.toggleBookmark}
                  isDashboardScreen={true}
                  headerControlsRight={[ 
                    <View style={[commonStyles.flex1, commonStyles.flexDirectionRow, commonStyles.alignItemsCenter]}>
                      <View tooltip={'Export to CSV'} style={[commonStyles.paddingRight16]} >
                        <Touchable onPress={() => this.convertToCSV()}>
                          <Image source={attachedFileIcon} style={commonStyles.icon18} />
                        </Touchable>
                      </View>
                    </View>,
                    <FilterIconComponent />
                  ]}
                />
                </View>
              )}
              </View>
          </View>
        </View>
      );
    }
  }
);

const styles = StyleSheet.create({
  statusWrapperStyle: {
    maxHeight: 26,
    minHeight: 26,
    marginBottom: 5,
  },
});
